import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc465ca2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cart-toolbar-footer" }
const _hoisted_2 = { class: "cart-toolbar-container" }




export default /*#__PURE__*/_defineComponent({
  __name: 'CartToolbar',
  emits: ['checkCart'],
  setup(__props, { emit: emits }) {



// 前往結帳
const preGotoCart = () => {
  emits('checkCart')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default"),
      _createElementVNode("div", { class: "cart-btn-list" }, [
        _createElementVNode("button", {
          type: "button",
          class: "cart-btn cart-btn-dark",
          onClick: preGotoCart
        }, "前往結帳")
      ])
    ])
  ]))
}
}

})